/*************************************************/
/* VIDEO                                         */
/*************************************************/
export function video() {
    const videoPlayerSelector = '.video-item__player';
    const videoPlayerPlayingClass = 'video-item__player--playing';

    const init = function () {
        const playYoutubeVideo = (playerElement, videoId) => {
            var iterations = 0;
            var loadViewTimer = setInterval(() => {
                if (youtubeLoaded) {
                    clearInterval(loadViewTimer);
                    let ytplayer = new YT.Player(playerElement, {
                        height: '100%',
                        width: '100%',
                        videoId: videoId,
                        host: 'https://www.youtube-nocookie.com',
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        },
                        playerVars: {
                            showinfo: 0,
                            rel: 0
                        }
                    });
                } else {
                    iterations++;
                }

                //Lets try for 10 seconds
                if (iterations === 100) {
                    clearInterval(loadViewTimer);
                }

            }, 50);
        }

        const playVideo = (playerId, context) => {
            const player = context ? context.querySelector(`#${playerId}`) : document.getElementById(playerId);

            if (!player) return;

            if (player.tagName == 'VIDEO') {
                player.play();
            } else {
                const v = player.querySelector('video');
                if (v) v.play();
            }

            const videoPlayerElement = player.closest(videoPlayerSelector);
            if (videoPlayerElement) {
                videoPlayerElement.classList.add(videoPlayerPlayingClass);
            }
        }

        const onPlayerReady = event => {
            event.target.playVideo();

            // 1. Get ALL elements that might match this video (Desktop AND Mobile)
            const videoId = event.target.playerInfo.videoData.video_id;
            const players = document.querySelectorAll(`#player${videoId}`);
            // 2. Find the one that is actually visible
            let activePlayer = null;
            players.forEach(p => {
                // If it has an offsetParent, it (and its parents) are NOT display: none
                if (p.offsetParent !== null) {
                    activePlayer = p;
                }
            });

            // 3. If we didn't find it by ID logic, use the direct Iframe reference
            const player = activePlayer || event.target.getIframe();
            const videoPlayerElement = player.closest(videoPlayerSelector);

            if (videoPlayerElement) {
                videoPlayerElement.classList.add(videoPlayerPlayingClass);
            }

        }

        const onPlayerStateChange = event => {
            if (event.data === YT.PlayerState.ENDED) {
                // Use getIframe() to find the EXACT player that just ended
                const playerIframe = event.target.getIframe();
                const videoPlayerElement = playerIframe.closest(videoPlayerSelector);

                if (videoPlayerElement) {
                    videoPlayerElement.classList.remove(videoPlayerPlayingClass);
                }
            }
        }

        const videoPlayerActionHandler = (e) => {
            const videoItem = e.target.closest(videoPlayerSelector);
            if (videoItem) {
                e.preventDefault();

                let videoId = videoItem.dataset.videoId;
                const playerId = videoItem.dataset.playerId;

                let videoSources = videoItem.dataset.videosources;
                let videoTypes = videoItem.dataset.videotypes;
                if (videoSources && videoTypes) {
                    videoSources = videoSources.split(',');
                    videoTypes = videoTypes.split(',');

                    const videoElement = document.createElement('video');
                    videoElement.controls = true;

                    for (let i = 0; i < videoSources.length; i++) {
                        const sourceElement = document.createElement('source');
                        sourceElement.setAttribute('src', videoSources[i]);
                        sourceElement.setAttribute('type', videoTypes[i]);
                        videoElement.appendChild(sourceElement)
                    }

                    const playerContainer = videoItem.querySelector(`#${playerId}`);
                    if (playerContainer) {
                        playerContainer.replaceChildren(videoElement);
                        playVideo(playerId, videoItem); // Pass the videoItem context
                    }

                }
                else if (typeof videoId != undefined && videoId != null && videoId != '') {
                    if (!Cookiebot.consent.marketing) {
                        CookieConsent.renew();
                    } else {
                        console.warn('Remember to setup the cookie consent solution for the Youtube script in video.js');
                        const tag = document.createElement('script');
                        tag.src = 'https://www.youtube.com/iframe_api';
                        const firstScriptTag = document.getElementsByTagName('script')[0];
                        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


                        //If video id is not set, it's probably a link from a RTE
                        if (typeof videoId === undefined) {
                            videoId = videoItem.querySelector('a').getAttribute('href');
                            if (videoId && videoId.indexOf('/') === 0 && videoId.length > 1) {
                                videoId = videoId.substr(1);
                            }
                        }
                        if (videoId) {
                            // Find the specific div for THIS video item
                            const playerContainer = videoItem.querySelector(`#${playerId}`);
                            if (playerContainer) {
                                // PASS THE ELEMENT, NOT THE ID STRING
                                playYoutubeVideo(playerContainer, videoId);
                            }
                        } else {
                            console.error('Video not found');
                        }
                    }
                }
            }
        }

        const videoPlayers = document.querySelectorAll(videoPlayerSelector);
        if (videoPlayers.length > 0) {
            videoPlayers.forEach(player => {

                player.addEventListener('click', e => {
                    //Only play the video if it's not already playing
                    const videoPlayer = player.querySelector('video');
                    if (!videoPlayer) {
                        videoPlayerActionHandler(e);
                    }
                });

                player.addEventListener('keyup', e => {
                    e.preventDefault();
                    if (e.key === 'Enter') {
                        videoPlayerActionHandler(e);
                    }
                });
            })
        }

    };

    init();
}
